import React from 'react'
import UIkit from 'uikit'
import { connect } from 'react-redux'
import introJs from 'intro.js';

// components
import Modal from '../../../UIkit/Modal'

class ModalLessonTourPt extends React.Component {
  constructor(props) {
    super(props)

    this.handleStartLessonTour = this.handleStartLessonTour.bind(this)
  }

  handleStartLessonTour() {
    UIkit.modal('#modal-lesson-tour').hide()

    const steps = [
      {
        element: document.querySelectorAll('#skill-steps')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Instruções de Aula</h4>
            <p>Esta área irá guiá-lo através de cada uma das etapas da lição, incluindo instruções sobre como realizar os exercícios práticos.</p>
            <p>Depois de terminar o primeiro passo, você precisará clicar no botão Avançar na parte inferior, que o levará para a próxima aula.</p>
          </div>
        `,
        tooltipPosition: 'right',
        position: 'right',
      }, {
        element: document.querySelectorAll('#browser')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Sandbox do Navegador</h4>
            <p>Este painel é a caixa de proteção do navegador e age muito semelhante a um navegador normal. Se você clicar no botão “View Source”, você pode ver o código-fonte do seu navegador. Muitas vulnerabilidades podem ser encontradas ao visualizar o código front-end de uma aplicação Web. Para voltar ao navegador, basta clicar em “View Browser”</p>
          </div>
        `,
        position: 'left',
      }, {
        element: document.querySelectorAll('#proxy-intercept')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Intercept Requests</h4>
            <p>Para ativar o proxy, verifique se o botão “Intercept Requests” está marcado. Isso manterá as solicitações HTTP enviadas aguardando até que você pressione o botão Enviar Solicitação. É uma boa ideia explorar aplicações Web com a intercepção desativada para que não o atrase. Mas uma vez que você começar a testar, é uma boa idéia tê-lo ativado para que você possa analisar as solicitações.</p>
          </div>
        `,
        position: 'bottom',
      }, {
        element: document.querySelectorAll('#proxy-status')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Proxy Status</h4>
            <p>O status do proxy informa se o proxy está ativado ou não. Clique nele para saber mais sobre cada tipo de estado.</p>
          </div>
        `,
        position: 'bottom',
      }, {
        element: document.querySelectorAll('#proxy-request-button')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Proxy</h4>
            <p>Este botão expande o aplicativo proxy que permite que você seja o man-in-the-middle ou o intermediário entre solicitações HTTP e respostas que vão de e para o navegador. O aplicativo também será exibido automaticamente se uma solicitação for interceptada.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'left',
      }, {
        element: document.querySelectorAll('#proxy-history-button')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Histórico de Proxy</h4>
            <p>A guia Histórico de Proxy exibe todas as solicitações e respostas HTTP. Se você clicar no sinal de adição ao lado da solicitação HTTP, você será capaz de ver cada uma das solicitações e suas respostas correspondentes. Isso é muito útil, pois permite visualizar respostas com base em solicitações anteriores.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-code-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Editor de Código</h4>
            <p>O Editor de código permite corrigir código vulnerável na caixa de proteção. Você pode alterar a linguagem de programação do código com o menu suspenso, e ver qualquer saída abaixo do editor de texto.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-code-output-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Saída de código e erros</h4>
            <p>Esta guia mostra que você imprimiu qualquer saída do código, o que pode ajudá-lo a depurá-lo. Ele funciona exatamente como a janela de console/terminal em seu ambiente de desenvolvimento habitual.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-patches-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Histórico de Patches</h4>
            <p>Esta guia mostra o histórico de todos os patches enviados. Mostra se você conseguiu ou não corrigir a vulnerabilidade com um patch específico e por que ela falhou.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-reset')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Reset Sandbox</h4>
            <p>Se você conseguir quebrar o aplicativo web no navegador sandbox e quiser uma nova inicialização, você pode pressionar o botão Reset Sandbox que irá gerar um novo aplicativo web.</p>
          </div>
        `,
        position: 'bottom',
      },
    ]

    if (this.props.showCode === false) {
      steps.splice(6, 1)
    }

    const tour = introJs()
      .setOptions({
        skipLabel: 'Pular Tour',
        showStepNumbers: false,
        hideNext: true,
        hidePrev: true,
        exitOnOverlayClick: false,
        disableInteraction: true,
        steps,
      })

    tour.start()
  }

  render() {
    return (
      <Modal
        id="modal-lesson-tour"
        titleTestId="title-modal-lesson-tour"
        title="Turnê de classe HackEDU"
        body={
          <div className="uk-text-center">
            <p>
              Este passeio irá guiá-lo através dos diferentes aspectos da nossa interface de aulas para a segurança de aplicações web.
            </p>
            <div className="uk-margin">
              <button
                className="uk-button uk-button-primary uk-margin-right uk-margin-remove-bottom"
                style={{
                  padding: '0 30px',
                }}
                onClick={this.handleStartLessonTour}
              >
                Faça o Tour
              </button>
              <button
                className="uk-button uk-button-muted uk-margin-remove-bottom"
                style={{
                  padding: '0 30px',
                }}
                onClick={() => { UIkit.modal('#modal-lesson-tour').hide() }}
                data-test-id="btn-tour-start-the-lesson"
              >
                Inicie a lição
              </button>
            </div>
          </div>
        }
        containerModifier
      />
    )
  }
}

const mapStateToProps = state => ({
  replFlag: state.repl.flag,
})
export default connect(mapStateToProps)(ModalLessonTourPt)
